import axios from "axios";
import moment from "moment";
import React from "react";
import { alertRef } from "../../../../App";
import DatePicker from "../../../../Components/DatePicker/DatePicker";
import { Button, Input } from "../../../../Components/StyledComponents";
import SetSMS from "../../Components/SetSMS/SetSMS";
import SetTarget from "../../Components/SetTarget/SetTarget";
import './PriceTarget.scss';

/* **** 
    VisitTarget 참고
    **** */

const PriceTarget = () => {
    const [startDate, setStartDate] = React.useState(new Date());//추출 시작 기간
    const [endDate, setEndDate] = React.useState(new Date());//추출 종료 기간
    const [startCount, setStartCount] = React.useState(0);//추출 시작 금액
    const [endCount, setEndCount] = React.useState(0);//추출 종료 금액
    const [ isChangeDate, setIsChangeDate ] = React.useState(false)//추출일 변경 여부 변경 없으면 전체 기간 추출
    
    const [ title, setTitle ] = React.useState('');
    const [ text, setText ] = React.useState('');
    const [ coupon, setCoupon ] = React.useState('');
    const [ gender, setGender ] = React.useState([])
    const [ age, setAge ] = React.useState([])
    const [ targetSort, setTargetSort ] = React.useState('');
    const [ reqCount, setReqCount ] = React.useState(0);
    const [ couponInfo, setCouponInfo ] = React.useState({})

    const [ targetCount, setTargetCount ] = React.useState(0);

    const getTarget = () => {
        axios.post('/api/sms/filter',{
            Type : 'Price',
            PointType : 'Remain',
            FilterRange : { Min : ( startCount ===0 && endCount === 0) ? 'All' : Number(startCount), Max : ( startCount ===0 && endCount === 0) ? 'All' : Number(endCount) },
            Day : 7,
            DateRange : { Start : ( !isChangeDate) ? 'All' : moment(startDate).format('YYYY-MM-DD'), End : ( !isChangeDate) ? 'All' : moment(endDate).format('YYYY-MM-DD')},
            Detail : {
                Age : age,
                Gender : gender,
                Limit : Number(reqCount),
                Sort : targetSort
            }
        })
        .then((data) => {
            if(data.status === 200){
                setTargetCount(data.data.TargetCount)
            }
        })
        .catch(() => {
            alertRef.current.showAlert({ title : `다시 시도해 주세요.`, isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })  
        })
    }

    const sendTargetSMS = () => {
        axios.put('/api/sms/filter',{
            Title : title,
            Body : text,
            Coupon : coupon,
            Type : 'Price',
            PointType : 'Remain',
            FilterRange : { Min : ( startCount ===0 && endCount === 0) ? 'All' : Number(startCount), Max : ( startCount ===0 && endCount === 0) ? 'All' : Number(endCount) },
            Day : 7,
            DateRange : { Start : ( !isChangeDate) ? 'All' : moment(startDate).format('YYYY-MM-DD'), End : ( !isChangeDate) ? 'All' : moment(endDate).format('YYYY-MM-DD')},
            Detail : {
                Age : age,
                Gender : gender,
                Limit : Number(reqCount),
                Sort : targetSort
            }
        })
        .then((data) => {
            if(data.status === 204 ){
                alertRef.current.showAlert({ title : `문자 발송이 완료 되었습니다.`, isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
            }else if(data.status === 200){
                alertRef.current.showAlert({ title : `보유 벨이 부족합니다.`, isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
            }
        })
        .catch(() => {
            alertRef.current.showAlert({ title : `네트워크 상태 혹은 보유벨을 확인해주세요.`, isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
        })
    }

    return (
        <div className="price-target">
            <div className="box">
                <p className="title">구매금액</p>

                <div className="row">
                    <DatePicker value={ startDate} onChange={(date) => {setStartDate(date); setIsChangeDate(true)}} style={{ width : 230 }} />
                    <p className="tilde">부터</p>
                    <DatePicker value={endDate} onChange={(date) => {setEndDate(date);setIsChangeDate(true);}} style={{ width : 230 }} />
                </div>

                <div className="row" style={{ marginTop : 24 }}>
                    <label htmlFor="pointEnd" data-domain="원">
                        <Input value={startCount} onChange={(e) => setStartCount(e.target.value)} style={{ width : 230, color : '#9f9f9f' }} />
                    </label>
                    <p className="tilde">~</p>
                    <label htmlFor="pointEnd" data-domain="원">
                        <Input value={endCount} onChange={(e) => setEndCount(e.target.value)} style={{ width : 230, color : '#9f9f9f' }} />
                    </label>
                </div>
                <p className="warn-text">설정한 기간내의 입력한 적립횟수</p>
            </div>

            <SetTarget gender={gender} setGender={setGender} age={age} setAge={setAge} targetSort={targetSort} setTargetSort={setTargetSort} reqCount={reqCount} setReqCount={setReqCount} getTarget={getTarget} targetCount={targetCount}/>

            <SetSMS smsTitle={title} setSMSTitle={setTitle} smsText={text} setSMSText={setText} coupon={coupon} setCoupon={setCoupon} couponInfo={couponInfo} setCouponInfo={setCouponInfo}/>

            <Button variant='outline' disabled={ title.trim() == '' || text.trim() === '' || targetCount === 0} className="send-btn" onClick={() => alertRef.current.showAlert({ title : `타겟 문자를 발송할까요?`, isConfirm : true, confirmText : '확인', isCancel : true, cancelText : '취소', onConfirm : () => {alertRef.current.hideAlert();sendTargetSMS()} })}>
                문자 발송하기
            </Button>
        </div>
    )
}

export default PriceTarget;